import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import './NoTableData.scss';

const NoTableData = ({ title, icon: Icon, message, children, className, titleClassName='my-4', messageClassName='my-4', iconSize=60 }) => {
  return (
    <Card className={'no-td-card text-center m-auto ' + className}>
      <CardBody>
        <div className={`no-td-card-title ${titleClassName}`}>{title}</div>
        <Icon className="no-td-card-icon m-2" size={iconSize} />
        <p className={`no-td-card-message ${messageClassName}`}>{message}</p>
        <div className="my-4">{children}</div>
      </CardBody>
    </Card>
  );
};

NoTableData.defaultProps = {
  className: '',
};

NoTableData.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
};

export default NoTableData;
